import { IConversationRestrictionOptions } from '@ui/components';

export const buildModeratorRestrictionsPayload = (
  restrictions: IConversationRestrictionOptions | undefined,
  moderatorIds: string[],
): IConversationRestrictionOptions => {
  const { moderators_profiles: _responseOnlyProfiles, ...persistedRestrictions } =
    restrictions || {};

  return {
    ...persistedRestrictions,
    moderators_ids: moderatorIds,
  };
};
